var map = {
	"./bg-exclusive.webp": 1346,
	"./border-bg-sm.png": 1347,
	"./border-bg-xm.png": 1348,
	"./border-bg.png": 1349,
	"./btn-active.png": 1350,
	"./casino-hover.webp": 1351,
	"./cny-flower-1.webp": 1352,
	"./cny-flower-2.webp": 1353,
	"./cny-mobile-bg.webp": 1354,
	"./content-deco-1.webp": 1355,
	"./content-deco-2.webp": 1356,
	"./content-deco-3.webp": 1357,
	"./content-deco-4.webp": 1358,
	"./content-deco-5.webp": 1359,
	"./deposit-icon.webp": 1360,
	"./event-border-hover.webp": 1361,
	"./games-hover.webp": 1362,
	"./home-icon-active.webp": 1363,
	"./home-icon.webp": 1364,
	"./live-icon-active.webp": 1365,
	"./live-icon.webp": 1366,
	"./lottery-hover.webp": 1367,
	"./master-bg.png": 1368,
	"./me-icon-active.webp": 1369,
	"./me-icon.webp": 1370,
	"./p2p-hover.webp": 1371,
	"./platform.webp": 1372,
	"./product-overview-bg.webp": 1373,
	"./promos-icon-active.webp": 1374,
	"./promos-icon.webp": 1375,
	"./slots-hover.webp": 1376,
	"./sponsor-icon-active.webp": 1377,
	"./sponsor-icon.webp": 1378,
	"./sports-hover.webp": 1379,
	"./title-deco-bg.webp": 1380,
	"./title-deco-left.webp": 1381,
	"./title-deco-right.webp": 1382,
	"./vip-icon-active.webp": 1383,
	"./vip-icon.webp": 1384,
	"./withdraw-icon.webp": 1385,
	"./wwr-bg.webp": 1386,
	"./wwr-img.webp": 1387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;